<template>
  <div :class="classes">
    <m4-checkbox :name="name" v-model="newValue" @update:modelValue="input" class="switch__field">
      <span></span>
    </m4-checkbox>
    <label class="switch__label"><slot></slot></label>
  </div>
</template>

<script>
import valueProp from "../../../utils/valueProp.js";

export default {
  name: "M4Switch",
  mixins: [valueProp],
  data() {
    return {
      newValue: this.modelValue ? this.modelValue : this.value
    };
  },
  props: {
    name: String,
    modelValue: [String, Number, Boolean, Function, Object, Array],
    size: {
      type: String,
      default() {
        return "sm";
      }
    }
  },
  emits: ["update:modelValue"],
  computed: {
    classes() {
      let classes = ["switch"];
      classes.push("switch--" + this.size);
      return classes;
    }
  },
  methods: {
    input(val) {
      this.newValue = val;
      this.$emit("update:modelValue", val);
    }
  },
  watch: {
    modelValue(val) {
      this.newValue = val;
    },
    value(value) {
      this.newValue = value;
    }
  }
};
</script>
